import React from 'react';
import { List } from 'semantic-ui-react'

import TitDer from '../../../components/funcionales/titder';

// import EstilosHome from '../../css/home.css';

// const Dato = ({styles, elemento}) => {
//   return(
//     <p style={styles.elemLis_1}>{elemento.codigoTipoOS} ={">"} {elemento.descrTipoOS}</p>
//   )};

// const DetalleNivel1 = ({styles, elemento, handleClickidLista}) => {
//   return (
//     <div className="ui middle aligned animated celled link list" style={styles.listaDer}>
//       <div className="item">
//         <List.Item onClick={(ev)=>handleClickidLista(ev, elemento)}>
//             <List.Header>
//                 <div className="floated content" style={styles.subElemLis_1}>
//                     <a className="header"><Dato styles={styles} elemento={elemento}/></a>
//                 </div>
//             </List.Header>
//         </List.Item>
//       </div>
//     </div>
//   )
// };

// const Lista = ({styles, list, handleClickidLista}) => {
//   const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 styles={styles} handleClickidLista={handleClickidLista} elemento={elemento} key={elemento._id} />);
//   return(
//     <div>
//       {nivel1Detalle}
//     </div>
//   )
// };




//Tipos de OS
const DetalleNivel1 = ({elemento, handleClickidLista}) => {
  return(
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className=''>{elemento.codigoTipoOS}</td>
      <td className=''>{elemento.descrTipoOS}</td>
      <td className=''>{elemento.generalCliente}</td>
      <td className=''>{elemento.estadoAlCrear}</td>
      <td className=''>{elemento.permDireccion}</td>
      <td className=''>{elemento.permTarServ}</td>
      {/* <td className=''>{elemento.permOfertas}</td> */}
      <td className=''>{elemento.permEquipos}</td>
      <td className=''>{elemento.paraCliNuevo}</td>
      <td className=''>{elemento.pedirPtosAdic}</td>
      <td className=''>{elemento.permImprimir}</td>
      <td className=''>{elemento.estadoCrearOS}</td>
      <td className=''>{elemento.estadoCerrarOS}</td>
      <td className=''>{elemento.genOSDirAnt}</td>
    </tr>
  )
};

const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} 
    handleClickidLista={handleClickidLista} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

const ConfTios2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
  const a252001 = autorizacUA.findIndex( autorizac => autorizac === "252001" );

  return (
    <div>
      <List selection>
        <TitDer list={list} textBoton1="Tipos de O de S" btnNuevo={a252001!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} />
        <div>
          <table className='ui blue inverted celled selectable table' style={styles.styTableSup}>
            <thead className=''>
              <tr className=''>
                <th className='' style={{width: '5%'}}>Código</th>
                <th className='' style={{width: '14%'}}>Descripción</th>
                <th className='' style={{width: '5%'}}>Tipo</th>
                <th className='' style={{width: '6%'}}>Al crear la OS debe quedar en estado</th>
                <th className='' style={{width: '11%'}}>Dirección</th>
                <th className='' style={{width: '17%'}}>Tarifa/Servicios</th>
                {/* <th className='' style={{width: '5%'}}>Ofertas</th> */}
                <th className='' style={{width: '9%'}}>Equipos</th>
                <th className='' style={{width: '5%'}}>Para clientes nuevos</th>
                <th className='' style={{width: '5%'}}>Pedir Ptos Adic</th>
                <th className='' style={{width: '5%'}}>Imprimir</th>
                <th className='' style={{width: '9%'}}>Estado del cliente al crear OS</th>
                <th className='' style={{width: '9%'}}>Estado del cliente al cerrar OS</th>
                <th className='' style={{width: '5%'}}>Gen OS a Dir Ant</th>
              </tr>
            </thead>
            <Lista list={list} handleClickidLista={handleClickidLista}/>
          </table>
          <p></p>
        </div>
      </List>
    </div>
  )
};

export default ConfTios2
